<div class="exception-row">
  <div class="period">
    <mat-form-field class="date-field">
      <mat-label>From</mat-label>
      <input
        (dateChange)="onPeriodStartChange($event.value)"
        [disabled]="!editMode"
        [matDatepicker]="startPicker"
        [value]="periodStartMoment"
        matInput />
      <mat-datepicker-toggle [for]="startPicker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <span class="period-separator">to</span>
    <mat-form-field class="date-field">
      <mat-label>To</mat-label>
      <input
        (dateChange)="onPeriodEndChange($event.value)"
        [disabled]="!editMode"
        [matDatepicker]="endPicker"
        [value]="periodEndMoment"
        matInput />
      <mat-datepicker-toggle [for]="endPicker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <gymfinder-opening-time-editor
    (valueChange)="onEditorValueChange($event)"
    [editMode]="editMode"
    [value]="editorValue">
  </gymfinder-opening-time-editor>

  @if (editMode) {
    <button
      (click)="remove()"
      color="warn"
      mat-icon-button
      matTooltip="Remove exception"
      type="button">
      <mat-icon>delete</mat-icon>
    </button>
  }

  @if (periodError) {
    <gymfinder-alert size="condensed" variant="error">{{ periodError }}</gymfinder-alert>
  }
</div>
